import React from 'react';
import Head from 'next/head';

interface OpenGraphImageProps{
  // add open graph image props here
  source : string;
  alt? : string;
  width? : number;
  height? : number;
}

const OpenGraphImage: React.FC<OpenGraphImageProps> = ({
  source,
  alt,
  width,
  height,
}: OpenGraphImageProps) => (
  <Head>
    <meta name="og:image" key="og:image" content={source} />

    {alt.length && (
      <meta name="og:image:alt" key="og:image:alt" content={alt} />
    )}

    {/* tags inside next/head cannot be accessed if nested in more than one fragment */}

    <meta
      property="og:image:width"
      key="og:image:width"
      content={width.toString()}
    />

    <meta
      property="og:image:height"
      key="og:image:height"
      content={height.toString()}
    />

  </Head>
);

OpenGraphImage.defaultProps = {
  alt: '' as string,
  width: 1200 as number,
  height: 630 as number,
};

export default OpenGraphImage;
